import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue";
import _imports_0 from './down.svg';
var _hoisted_1 = {
  key: 0,
  class: "resource-detail"
};
var _hoisted_2 = {
  key: 0,
  class: "resource-info"
};
import { reactive, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { MessagePlugin } from 'tdesign-vue-next';
import sendEvent from 'hxhy-send-track';
import { getStore } from '@/util/store';
/* 组件 */
import kanshanVideo from './kanshanVideo';
import preview from './preview';
import leftBar from './leftBar';
/* api */
import { getResourceInfo, getPersonResourceInfo } from '@/api/resources';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
export default {
  __name: 'index',
  setup: function setup(__props) {
    /* 工具 */
    var fpPromise = FingerprintJS.load();
    /* 变量 */
    var allResourceType = [{
      value: 1,
      label: '教案'
    }, {
      value: 2,
      label: '课件'
    }, {
      value: 3,
      label: '习题'
    }, {
      value: 4,
      label: '素材'
    }, {
      value: 5,
      label: '资源包'
    }, {
      value: 6,
      label: '微课'
    }, {
      value: 7,
      label: '试卷'
    }, {
      value: 9,
      label: '学程(电子版)'
    }, {
      value: 11,
      label: '纪录片'
    }, {
      value: 12,
      label: '优质资源'
    }, {
      value: 8,
      label: '其他'
    }];
    var route = useRoute();
    var state = reactive({
      sourceData: {},
      isLoad: false
    });
    var token = getStore({
      name: 'access_token'
    });
    var startTime = null;
    var endTime = null;
    var trackTimer = null;
    /* 方法 */
    var getLibResource = function getLibResource() {
      getResourceInfo(route.query.id).then(function (res) {
        if (res.data.code === 0) {
          state.sourceData = res.data.data || {};
          state.isLoad = true;
          setSendEvent();
        }
      });
    };
    var getPerResource = function getPerResource() {
      getPersonResourceInfo(route.query.id).then(function (res) {
        if (res.data.code === 0) {
          state.sourceData = res.data.data || {};
          state.isLoad = true;
          setSendEvent();
        }
      });
    };
    var downSource = function downSource() {
      var _window = window,
        JSAndroid = _window.JSAndroid;
      if (typeof JSAndroid !== 'undefined') {
        var data = {
          title: state.sourceData.name,
          url: state.sourceData.url || state.sourceData.path
        };
        JSAndroid.downLoadSource(JSON.stringify(data));
        MessagePlugin.success('下载任务创建成功');
      } else {
        var link = document.createElement('a');
        link.href = state.sourceData.url || state.sourceData.path;
        link.download = state.sourceData.name;
        document.body.appendChild(link);
        link.click();
        window.setTimeout(function () {
          document.body.removeChild(link);
        }, 0);
      }
    };

    // 资源预览埋点
    var sendPoint = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(duration) {
        var _window2, _getStore, _getStore2, _getStore3, _getStore4;
        var _state$sourceData, sourceId, name, scene, subjectId, subjectName, fileType, lessonInfo, customParam, eventSource, fp, result, common;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _state$sourceData = state === null || state === void 0 ? void 0 : state.sourceData, sourceId = _state$sourceData.sourceId, name = _state$sourceData.name, scene = _state$sourceData.scene, subjectId = _state$sourceData.subjectId, subjectName = _state$sourceData.subjectName, fileType = _state$sourceData.fileType;
              lessonInfo = (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.JSAndroid.getAppInfo();
              customParam = {
                scene: scene,
                resource_id: sourceId,
                resource_name: name,
                view_time_long: duration,
                subject_id: subjectId,
                subject_name: subjectName,
                resource_type: fileType,
                is_in_lesson: (lessonInfo === null || lessonInfo === void 0 ? void 0 : lessonInfo.is_in_class) || '课堂外'
              };
              eventSource = [{
                eventCode: 'Resource_resource_user_open',
                eventTime: new Date().getTime(),
                userId: ((_getStore = getStore({
                  name: 'accessInfo'
                })) === null || _getStore === void 0 ? void 0 : _getStore.user_id) || ((_getStore2 = getStore({
                  name: 'userInfo'
                })) === null || _getStore2 === void 0 ? void 0 : _getStore2.id),
                userName: ((_getStore3 = getStore({
                  name: 'accessInfo'
                })) === null || _getStore3 === void 0 ? void 0 : _getStore3.name) || ((_getStore4 = getStore({
                  name: 'userInfo'
                })) === null || _getStore4 === void 0 ? void 0 : _getStore4.name),
                customParam: JSON.stringify(customParam)
              }];
              if (!(window.JSAndroid && window.JSAndroid.eventHeartBeat)) {
                _context.n = 3;
                break;
              }
              _context.n = 1;
              return fpPromise;
            case 1:
              fp = _context.v;
              _context.n = 2;
              return fp.get();
            case 2:
              result = _context.v;
              common = {
                device: {
                  osType: navigator.platform,
                  osVersion: navigator.appVersion,
                  deviceld: result.visitorId,
                  macAddress: '',
                  screenWidth: screen && screen.width || document.body.clientWidth,
                  screenHeight: screen && screen.height || document.body.clientHeight,
                  userAgent: navigator.userAgent
                },
                platform: {
                  appType: 'web',
                  appVersion: 0
                },
                eventDatas: eventSource
              };
              window.JSAndroid.eventHeartBeat(token + '-' + String(startTime), 5, JSON.stringify(common));
              _context.n = 4;
              break;
            case 3:
              sendEvent(eventSource);
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function sendPoint(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    // 开启埋点
    var setSendEvent = function setSendEvent() {
      startTime = new Date(); // 记录开始时间
      if (window.JSAndroid && window.JSAndroid.eventHeartBeat) {
        if (trackTimer) {
          clearInterval(trackTimer);
          trackTimer = null;
        }
        trackTimer = setInterval(function () {
          endTime = new Date(); // 记录结束时间
          var duration = (endTime - startTime) / 1000; // 计算持续时间，单位为秒
          sendPoint(duration);
        }, 2000);
      }
    };
    onMounted(function () {
      var _route$query = route.query,
        id = _route$query.id,
        url = _route$query.url;
      if (id) {
        route.query.source === '1' ? getPerResource() : getLibResource();
      } else {
        url && (state.sourceData.url = url);
        state.isLoad = true;
        setSendEvent();
      }
    });
    onUnmounted(function () {
      if (window.JSAndroid && window.JSAndroid.eventHeartBeat) {
        clearInterval(trackTimer);
        trackTimer = null;
      } else {
        endTime = new Date(); // 记录结束时间
        var duration = (endTime - startTime) / 1000; // 计算持续时间，单位为秒
        sendPoint(duration);
      }
    });
    return function (_ctx, _cache) {
      return state.isLoad ? (_openBlock(), _createElementBlock("div", _hoisted_1, [state.sourceData.name ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(state.sourceData.name), 1)])) : _createCommentVNode("", true), state.sourceData && state.sourceData.sourceType === 2 && state.sourceData.formatType.toUpperCase() === 'VS4' ? (_openBlock(), _createBlock(_unref(kanshanVideo), {
        key: 1,
        "video-player-id": state.sourceData.path,
        "video-url": state.sourceData.path,
        "video-poster": state.sourceData.coverPath,
        "ks-resource-id": state.sourceData.sourceId,
        "sub-title": state.sourceData.subtitle
      }, null, 8, ["video-player-id", "video-url", "video-poster", "ks-resource-id", "sub-title"])) : (_openBlock(), _createBlock(_unref(preview), {
        key: 2,
        path: state.sourceData.url
      }, null, 8, ["path"])), state.sourceData.id ? (_openBlock(), _createBlock(_unref(leftBar), {
        key: 3,
        data: state.sourceData
      }, null, 8, ["data"])) : _createCommentVNode("", true), state.sourceData.id ? (_openBlock(), _createElementBlock("div", {
        key: 4,
        class: "down-bar",
        onClick: downSource
      }, _toConsumableArray(_cache[0] || (_cache[0] = [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1)])))) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }
};